/* eslint-disable react/prop-types */
import {
  Button,
  CircularProgress,
  Dialog,
  Divider,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import {
  ADD_PIPELINE_OWNER,
  ADD_PROPERTY_OWNER,
  VENDOR_CHECK_IN,
} from 'constant/app.config';
import React, { useRef, useState, useEffect } from 'react';
import { poppins400, poppins500 } from 'theme/common.style';
import './AddListing.css';
import './PropertyCreation.css';
import {
  checkbox_style,
  textboxmargin,
  typography_textfield,
} from './PropertyCreation.style';
import { toast } from 'react-toastify';
import { Avatar, Card } from 'antd';
import Dp from 'assets/dummy/buy.jpg';
import {
  BuyerCheckLbl,
  displayFlex,
} from 'component/ActivityContainer/ActivityContainer.style';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import Swal from 'sweetalert2';
import { TextFieldError } from 'component/SignupForm/SignupForm.style';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Loading from 'assets/images/loading.png';

export default function AddListingModal({
  value,
  setValue,
  onClose,
  fromHeader,
  responseData,
  setResponseData,
  responseProp,
  setResponseProp,
  responseTempId,
  setResponseTempId,
  sectionRef,
  dashboardcount,
  prefillData,
  pipelineTempId,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [data, setData] = useState([' ']);
  const [companyname, setCompanyname] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [legalname, setLegalname] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [primary, setPrimary] = useState(false);
  const [individual, setIndividual] = useState(false);
  const [company, setCompany] = useState(false);
  const [emailError, setEmailError] = useState('');
  const companytyperef = useRef(null);

  useEffect(() => {
    if (prefillData) {
      const propertyObj = prefillData?.property || prefillData;
      const ownerObj = prefillData?.owner || prefillData;
      const ownerDetailsList =
        (Array.isArray(ownerObj?.ownerDetails) &&
          ownerObj.ownerDetails.length > 0 &&
          ownerObj.ownerDetails) ||
        (Array.isArray(propertyObj?.ownerDetails) &&
          propertyObj.ownerDetails.length > 0 &&
          propertyObj.ownerDetails) ||
        (Array.isArray(prefillData?.ownerDetails) &&
          prefillData.ownerDetails.length > 0 &&
          prefillData.ownerDetails) ||
        (ownerObj ? [ownerObj] : []);

      if (ownerDetailsList.length > 0) {
        const firstOwner = ownerDetailsList[0];
        const fn =
          firstOwner.ownerFirstName ||
          firstOwner.firstName ||
          firstOwner.firstname ||
          '';
        const ln =
          firstOwner.ownerSurName ||
          firstOwner.ownerLastName ||
          firstOwner.lastName ||
          firstOwner.lastname ||
          '';
        const em = firstOwner.ownerEmail || firstOwner.email || '';
        const mb = firstOwner.ownerMobileNo || firstOwner.mobile || '';
        const cn = firstOwner.companyName || firstOwner.companyname || '';
        const lg = firstOwner.legalName || firstOwner.legalname || '';

        if (fn) setFirstname(fn);
        if (ln) setLastname(ln);
        if (em) setEmail(em);
        if (mb) setMobile(mb);
        if (cn) {
          setCompanyname(cn);
          setCompany(true);
          setIndividual(false);
          setChecked(true);
        } else {
          setIndividual(true);
          setCompany(false);
          setChecked(false);
        }
        if (lg) setLegalname(lg);

        const mappedOwners = ownerDetailsList.map((item) => {
          const isPrimary =
            item.isPrimaryOwner === 1 || item.isPrimaryOwner === '1';

          return {
            companyname: item.companyName || item.companyname || '',
            firstname:
              item.ownerFirstName || item.firstName || item.firstname || '',
            lastname:
              item.ownerSurName ||
              item.ownerLastName ||
              item.lastName ||
              item.lastname ||
              '',
            legalname: item.legalName || item.legalname || '',
            email: item.ownerEmail || item.email || '',
            mobile: item.ownerMobileNo || item.mobile || '',
            primary: isPrimary,
            individual: !(item.companyName || item.companyname),
            company: item.companyName || item.companyname || '',
          };
        });

        setOwners(mappedOwners);
      }
    }
  }, [prefillData]);

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  const theme = useTheme();
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches = useMediaQuery(theme.breakpoints.between(900, 950));

  const [individualChecked, setIndividualChecked] = useState(false);
  const [companyChecked, setCompanyChecked] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [errorMessage, setErrorMessage] = useState({
    helperText: '',
    error: false,
  });

  const [errorMessageCompanyType, setErrorMessageCompanyType] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageCompanyName, setErrorMessageCompanyName] = useState({
    helperText: '',
    error: false,
  });

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentActiveIndex, setCurrentActiveIndex] = useState(null);

  const BuyerCallIcon = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.5"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6164 11.6322C10.7873 11.3492 11.7287 10.3202 12.4005 10.3513C12.6014 10.3679 12.7789 10.4894 12.9231 10.6303C13.2543 10.9537 14.2024 12.1769 14.2562 12.4343C14.3871 13.0656 13.6349 13.4295 13.8651 14.0658C14.452 15.502 15.4634 16.5132 16.9002 17.0996C17.5359 17.3298 17.8999 16.5776 18.5312 16.7091C18.788 16.7629 20.0118 17.7109 20.3353 18.0421C20.4756 18.1858 20.5977 18.3638 20.6143 18.5646C20.6393 19.2719 19.5464 20.2266 19.3334 20.3487C18.8308 20.7081 18.175 20.702 17.3756 20.3303C15.1449 19.4023 11.58 15.9047 10.6347 13.5898C10.273 12.7949 10.2481 12.1347 10.6164 11.6322Z"
          stroke="#6C2AD2"
          stroke-width="0.81025"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const BuyerMsgIcon = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.5"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M8 11.5C8 10.3954 8.89543 9.5 10 9.5H21C22.1046 9.5 23 10.3954 23 11.5V18.125C23 19.2296 22.1046 20.125 21 20.125H10C8.89543 20.125 8 19.2296 8 18.125V11.5Z"
          stroke="#6C2AD2"
          stroke-linejoin="round"
        />
        <path
          d="M9.42131 10.8029C8.91709 10.3407 9.24409 9.5 9.9281 9.5H21.0719C21.7559 9.5 22.0829 10.3407 21.5787 10.8029L17.5272 14.5168C16.3802 15.5681 14.6198 15.5681 13.4728 14.5168L9.42131 10.8029Z"
          stroke="#6C2AD2"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  function CircularProgressWithProfile(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={43}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={43}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            <Avatar
              alt="Remy"
              src={Dp}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          </Typography>
        </Box>
      </Box>
    );
  }

  const [foundData, setFoundData] = useState(false);
  const [anchorEl, setAnchorEl] = useState('');
  const [checkInData, setCheckInData] = useState();
  const [checkInIndex, setCheckInIndex] = useState();
  const [checkInErrorData, setCheckInErrorData] = useState();

  const [lnameAnchorEl, setLnameAnchorEl] = useState('');
  const [legalAnchorEl, setLegalAnchorEl] = useState('');
  const [emailAnchorEl, setEmailAnchorEl] = useState('');
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null);

  const [userDetails, setUserDetails] = useState([
    {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      legalName: '',
    },
  ]);

  const [userSelected, setUserSelected] = useState(false);

  const vendorCheckin = (data) => {
    if (!data || data.length === 0) {
      // When value is removed, DO NOT call API
      return;
    }

    const inputData = { contactValue: data };

    setFoundData(true);

    postApiCall(VENDOR_CHECK_IN, inputData).then((res) => {
      if (res?.data?.status == 1) {
        setCheckInData(res?.data);
        setCheckInErrorData('');
      } else {
        setCheckInErrorData(res?.data);
      }
      setFoundData(false);
    });
  };

  const handleMatchData = (index, i) => {
    // Destructure the data to be set
    const firstName = checkInData?.userData[i]?.userName || '';
    const lastName = checkInData?.userData[i]?.userSurName || '';
    const email = checkInData?.userData[i]?.userEmail || '';
    let phone = checkInData?.userData[i]?.userPhone || '';
    phone = phone
      .replace(/\D/g, '')
      .replace(/^(\d{4})(\d{3})(\d{3})$/, '$1 $2 $3');

    setMobileErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = '';
      return newErrors;
    });

    const legalName = checkInData?.userData[i]?.legalName || '';

    setLegalnameErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = '';
      return newErrors;
    });

    setLastnameErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = '';
      return newErrors;
    });
    // Update userDetails state first
    setUserDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = { firstName, lastName, email, phone, legalName };
      return updatedDetails;
    });

    // Update the owners state in one go
    handleOwnerChange(index, null, {
      firstname: firstName,
      lastname: lastName,
      email: email,
      mobile: phone,
      legalname: legalName,
    });

    setMobileAnchorEl(null);
  };

  const handleOwnerChange = (index, property, newValue) => {
    const updatedOwners = owners.map((owner, i) => {
      if (i === index) {
        let updatedOwner = owner;

        if (property) {
          updatedOwner = { ...owner, [property]: newValue };

          if (property === 'email') {
            // Email-specific logic
            if (!validateEmail(newValue)) {
              setEmailErrors((prevErrors) => {
                const newErrors = [...prevErrors];
                newErrors[index] = '';
                return newErrors;
              });
            } else {
              setEmailErrors((prevErrors) => {
                const newErrors = [...prevErrors];
                newErrors[index] = '';
                return newErrors;
              });
            }
          }
        } else {
          updatedOwner = { ...owner, ...newValue };
          // You might want to run email validation here as well
          if (newValue.email) {
            if (!validateEmail(newValue.email)) {
              setEmailErrors((prevErrors) => {
                const newErrors = [...prevErrors];
                newErrors[index] = 'Invalid email';
                return newErrors;
              });
            } else {
              setEmailErrors((prevErrors) => {
                const newErrors = [...prevErrors];
                newErrors[index] = '';
                return newErrors;
              });
            }
          }
        }

        return updatedOwner;
      }
      return owner;
    });

    setOwners(updatedOwners);
  };

  const validateEmail = (inputEmail) => {
    const emailPattern = /^(?!.*\.\.)[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailPattern.test(inputEmail);
  };
  const handleIndividualChange = () => {
    setIndividual(true);
    setCompany(false);
    setChecked(false);
    setCompanyname('');
    setErrorMessageCompanyType({ helperText: '', error: false });
  };

  const handleCompanyChange = () => {
    setIndividual(false);
    setCompany(true);
    setChecked(true);
    setErrorMessageCompanyType({ helperText: '', error: false });
  };

  const handleKeyPress = (event) => {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  };
  const [owners, setOwners] = useState([
    {
      companyname: companyname,
      firstname: '',
      lastname: '',
      legalname: '',
      email: '',
      mobile: '',
      primary: true,
      individual: false,
      company: '',
    },
  ]);

  const handlePrimaryChange = (index) => {
    const updatedOwners = owners.map((owner, i) => ({
      ...owner,
      primary: i === index,
    }));
    // window.scrollTo({
    //   top: document.getElementById(`owner-${index}`).offsetTop,
    //   behavior: 'smooth',
    // });
    setOwners(updatedOwners);
  };

  const handleClick = () => {
    setOwners([
      ...owners,
      { firstname: '', lastname: '', email: '', mobile: '', legalname: '' },
    ]);
  };
  const handleOwnerDelete = (index) => {
    let result = [...owners];
    const deletedOwner = result[index];
    result.splice(index, 1);

    if (deletedOwner.primary && result.length > 0) {
      result[0].primary = true;
    }

    if (!result.some((o) => o.primary) && result.length > 0) {
      result[0].primary = true;
    }

    setOwners(result);
  };
  const [mobileErrors, setMobileErrors] = useState(
    Array.from({ length: owners.length }, () => '')
  );
  const [nameErrors, setNameErrors] = useState(
    Array.from({ length: owners.length }, () => '')
  );
  const [lastnameErrors, setLastnameErrors] = useState(
    Array.from({ length: owners.length }, () => '')
  );
  const [legalnameErrors, setLegalnameErrors] = useState(
    Array.from({ length: owners.length }, () => '')
  );
  const [emailErrors, setEmailErrors] = useState(
    Array.from({ length: owners.length }, () => '')
  );

  const inputRefs = useRef([]);

  // const handleMobileChange = (event, index) => {
  //   const inputElement = inputRefs.current[index];
  //   const rawValue = event.target.value;

  //   const prevValue = inputElement?.value || '';
  //   const currentCursor = inputElement?.selectionStart || 0;

  //   // Remove non-digits
  //   const numericValue = rawValue.replace(/\D/g, "");

  //   // Format mobile number: 04XX XXX XXX
  //   let formattedValue = numericValue.replace(/^(\d{0,4})(\d{0,3})(\d{0,3})$/, "$1 $2 $3").trim();

  //   // Mobile number validation
  //   let error = "";
  //   if (!/^04\d{2}\s?\d{3}\s?\d{3}$/.test(formattedValue) && formattedValue.length > 0) {
  //     error = "Mobile number format should be: 04XX XXX XXX";
  //   }

  //   // Set value and error
  //   setMobile(formattedValue);
  //   setMobileErrors((prevErrors) => {
  //     const newErrors = [...prevErrors];
  //     newErrors[index] = error;
  //     return newErrors;
  //   });

  //   handleOwnerChange(index, "mobile", formattedValue);

  //   // Handle cursor positioning
  //   requestAnimationFrame(() => {
  //     if (!inputElement) return;

  //     // Count digits before currentCursor in raw input
  //     const digitsBeforeCursor = rawValue.slice(0, currentCursor).replace(/\D/g, "").length;

  //     // Move cursor to correct position in new formatted value
  //     let newCursor = 0;
  //     let digitCount = 0;

  //     while (digitCount < digitsBeforeCursor && newCursor < formattedValue.length) {
  //       if (/\d/.test(formattedValue[newCursor])) {
  //         digitCount++;
  //       }
  //       newCursor++;
  //     }

  //     // Set cursor at calculated position
  //     inputElement.setSelectionRange(newCursor, newCursor);
  //   });
  // };

  const handleMobileChange = (event, index) => {
    const inputElement = inputRefs.current[index];
    const rawValue = event.target.value;
    const prevValue = inputElement?.value || '';
    const cursorPosition = inputElement?.selectionStart || 0;

    // Detect if user is deleting
    const isBackspace = prevValue.length > rawValue.length;

    // Get raw numeric value
    const numericValue = rawValue.replace(/\D/g, '');

    // Format number normally
    let formattedValue = numericValue
      .replace(/^(\d{0,4})(\d{0,3})(\d{0,3})$/, '$1 $2 $3')
      .trim();

    // Cursor fix logic
    let newCursorPosition = cursorPosition;

    // Special handling: if deleting a space, don't re-insert it
    if (isBackspace && prevValue[cursorPosition] === ' ') {
      // Manually shift cursor one back
      newCursorPosition = cursorPosition - 1;
    }

    // Validate format
    let error = '';
    const numericOnly = formattedValue.replace(/\s/g, '');
    if (numericOnly.length > 0 && !/^04\d{2}\d{3}\d{3}$/.test(numericOnly)) {
      error = 'Mobile number format should be: 04XX XXX XXX';
    }

    // Set values
    setMobile(formattedValue);
    setMobileErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = error;
      return newErrors;
    });

    handleOwnerChange(index, 'mobile', formattedValue);

    // Apply cursor position
    requestAnimationFrame(() => {
      if (!inputElement) return;

      // Recalculate cursor based on number of digits before original cursor
      const digitsBeforeCursor = rawValue
        .slice(0, cursorPosition)
        .replace(/\D/g, '').length;
      let actualCursor = 0;
      let digitCount = 0;
      while (
        digitCount < digitsBeforeCursor &&
        actualCursor < formattedValue.length
      ) {
        if (/\d/.test(formattedValue[actualCursor])) {
          digitCount++;
        }
        actualCursor++;
      }

      inputElement.setSelectionRange(actualCursor, actualCursor);
    });
  };

  const [addMoreField, setAddmorefield] = React.useState(false);

  const openAddFieldConfirmBox = () => {
    setAddmorefield(true);
  };
  const closeAddFieldConfirmBox = () => {
    setAddmorefield(false);
    onClose();
  };

  const confirmAddmoreField = () => {
    setValue(2);
    setAddmorefield(false);
  };

  const handleOwnershipSubmit = () => {
    let isValid = true;

    if (!individual && !company) {
      setErrorMessageCompanyType({
        helperText: 'Select Owner type',
        error: true,
      });
      companytyperef.current.focus();
      isValid = false;
      return;
    }
    if (checked && companyname === '') {
      setErrorMessageCompanyName({
        helperText: 'Please enter a company name',
        error: true,
      });
      companytyperef.current.focus();
      isValid = false;
      return;
    }

    owners?.map((item, index) => {
      if (item.firstname === '') {
        setNameErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = 'Please enter first name';
          return newErrors;
        });
        isValid = false;
      } else {
        setNameErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = '';
          return newErrors;
        });
      }
      if (item.lastname === '') {
        setLastnameErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = 'Please enter last name';
          return newErrors;
        });
        isValid = false;
      } else {
        setLastnameErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = '';
          return newErrors;
        });
      }
      if (item.legalname === '') {
        setLegalnameErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = 'Please enter legal name';
          return newErrors;
        });
        isValid = false;
      } else {
        setLegalnameErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = '';
          return newErrors;
        });
      }
      if (item.email === '') {
        setEmailErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = 'Please enter email address';
          return newErrors;
        });
        isValid = false;
      } else {
        if (!validateEmail(item.email)) {
          setEmailErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = 'Please enter correct email address';
            return newErrors;
          });
          isValid = false;
        } else {
          setEmailErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = '';
            return newErrors;
          });
        }
      }
      if (item.mobile === '') {
        setMobileErrors((prevErrors) => {
          const newErrors = [...prevErrors];
          newErrors[index] = 'Enter an Australian mobile number (10 digits)';
          return newErrors;
        });
        isValid = false;
      } else {
        const mobilePattern = /^04\d{2}\s?\d{3}\s?\d{3}$/;
        if (!mobilePattern.test(item.mobile)) {
          let error = 'Mobile number format should be: 04XX XXX XXX';
          setMobileErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = error;
            return newErrors;
          });
          isValid = false;
        } else {
          setMobileErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = '';
            return newErrors;
          });
        }
      }
      if (item.email !== '') {
        const emailIndexes = owners
          .map((owner, i) => (owner.email === item.email ? i : -1))
          .filter((i) => i !== -1);

        if (emailIndexes.length > 1 && index !== emailIndexes[0]) {
          setEmailErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = 'This email is already used by another owner';
            return newErrors;
          });
          isValid = false;
        }
      }
      const mobilePattern = /^04\d{2}\s?\d{3}\s?\d{3}$/;
      //Run duplicate check ONLY if mobile is NON-empty AND VALID
      if (item.mobile && mobilePattern.test(item.mobile)) {
        const mobileIndexes = owners
          .map((owner, i) => (owner.mobile === item.mobile ? i : -1))
          .filter((i) => i !== -1);

        if (mobileIndexes.length > 1 && index !== mobileIndexes[0]) {
          setMobileErrors((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] =
              'This mobile number is already used by another owner';
            return newErrors;
          });
          isValid = false;
        }
      }
    });

    // Perform mobile number validation
    if (!isValid) {
      return; // Exit early if validation failed
    }

    // if(mobile){
    //   const mobilePattern = /^04\d{2}\s?\d{3}\s?\d{3}$/;
    //   if (!mobilePattern.test(mobile)) {
    //     setMobileErrors('Mobile number format should be: 04XX XXX XXX');
    //     return;
    //   }

    // }

    setLoading(true);
    const ownerData = owners.map((owner) => ({
      ownerFirstName: owner.firstname.trim(),
      ownerSurName: owner.lastname.trim(),
      ownerEmail: owner.email,
      ownerMobileNo: owner.mobile,
      isPrimaryOwner: owner.primary ? 1 : 0,
      legalName: owner.legalname.trim(),
      ownershipType: individual ? 'Individual' : company ? 'Company' : 'null',
      companyName: companyname,
    }));

    const pipelinePropId =
      prefillData?.property?.propertyId ||
      prefillData?.propertyId ||
      pipelineTempId ||
      localStorage.getItem('pipelinePropertyId') ||
      '';

    // for ownerdetailsalone
    if (
      !prefillData &&
      (fromHeader == 'property' ||
        fromHeader == 'owner' ||
        fromHeader == 'appraisal')
    ) {
      const params = {
        ownerData,
        propertyId: responseProp,
        tempId: responseTempId,
      };
      if (isValid) {
        postApiCall(ADD_PIPELINE_OWNER, params)
          .then((res) => {
            if (res.data?.status === -1) {
              // Handle error
              toast.error(res.data.message, {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                progress: 0,
                theme: 'light',
                style: {
                  fontFamily: 'Poppins', // 👈 Inline Poppins font
                },
              });
            } else {
              const isNotEmptyArray = (arr) =>
                Array.isArray(arr) &&
                arr.length > 0 &&
                !arr.every((item) => Array.isArray(item) && item.length === 0);

              // if (isNotEmptyArray(res?.data?.binderData?.requestData))
              //   Moxoseparationinlisting("dataForVendorPipelineAgentBinder", res?.data?.binderData?.requestData);
              if (isNotEmptyArray(res?.data?.binderAdminData?.requestData))
                Moxoseparationinlisting(
                  'dataForVendorPipelineAdminBinder',
                  res?.data?.binderAdminData?.requestData
                ); //2

              if (isNotEmptyArray(res?.data?.binderData?.requestData)) {
                try {
                  Moxoseparationinlisting(
                    'dataForVendorPipelineAgentBinder',
                    res?.data?.binderData?.requestData
                  );
                } catch (err) {
                  console.error('Error in Moxoseparationinlisting:', err);
                }
              }
              localStorage.setItem('tempid', res?.data?.tempId);
              localStorage.setItem('ownerTempId', res?.data?.ownerTempId);

              if (fromHeader == 'owner' || fromHeader == 'appraisal') {
                setResponseData([...res?.data?.vendorIds]);
              }

              if (fromHeader == 'appraisal') {
                const primaryOwner = ownerData.find(
                  (owner) => owner.isPrimaryOwner == 1
                );
                const fullName = `${primaryOwner?.ownerFirstName || ''} ${
                  primaryOwner?.ownerSurName || ''
                }`.trim();
                localStorage.setItem('primaryOwnerName', fullName);
                setValue(2);
              } else {
                Swal.fire({
                  title: res?.data?.heading,
                  text: res?.data?.desc,
                  showConfirmButton: true,
                  showCancelButton: fromHeader !== 'property',
                  icon: 'success',
                  confirmButtonText:
                    fromHeader == 'property' ? 'Close' : 'Continue',
                  cancelButtonText: 'Cancel',
                  reverseButtons: true,
                }).then((result) => {
                  if (result.isConfirmed) {
                    if (fromHeader == 'property') {
                      onClose();
                    } else {
                      confirmAddmoreField();
                    }
                  } else if (result.isDismissed) {
                    onClose();
                  }
                });
              }
            }
          })
          .catch((err) => setLoading(false))
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      const params = {
        ownerData,
        ...(prefillData && pipelinePropId
          ? { pipelineTempId: pipelinePropId }
          : {}),
      };
      if (isValid) {
        postApiCall(ADD_PROPERTY_OWNER, params)
          .then((res) => {
            if (res.data?.status === -1) {
              // Handle error
              toast.error(res.data.message, {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                progress: 0,
                theme: 'light',
                style: {
                  fontFamily: 'Poppins', // 👈 Inline Poppins font
                },
              });
              const { heading, message } = res.data;

              if (currentActiveIndex != null) {
                if (heading == 'Name Mismatch') {
                  setNameErrors((prevErrors) => {
                    const newErrors = [...prevErrors];
                    newErrors[currentActiveIndex] = message;
                    return newErrors;
                  });
                } else if (heading == 'Mobile Not Found.') {
                  setMobileErrors((prevErrors) => {
                    const newErrors = [...prevErrors];
                    newErrors[currentActiveIndex] = message;
                    return newErrors;
                  });
                }
              }
            } else {
              localStorage.setItem('tempid', res?.data?.tempId);
              setValue(value + 1);
              dashboardcount?.();
            }
          })
          .catch((err) => setLoading(false))
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          handleOwnershipSubmit();
          e.preventDefault();
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography className={classes.ownerTitle}>
              Owner Details
            </Typography>
          </Grid>
          <Grid className={classes.GridRow} item xs={12} sm={12} md={12}>
            <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8}>
              <Stack flexDirection={'row'}>
                <Typography>
                  <input
                    name="option"
                    type="checkbox"
                    checked={individual}
                    tabIndex="-1"
                    autoFocus
                    onChange={handleIndividualChange}
                    ref={companytyperef}
                    disabled={loading}
                  />
                </Typography>
                <Typography sx={checkbox_style}>&nbsp; Individual</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8}>
              <Stack flexDirection={'row'}>
                <Typography>
                  <input
                    type="checkbox"
                    name="option"
                    checked={company}
                    tabIndex="-1"
                    onChange={handleCompanyChange}
                    disabled={loading}
                  />
                </Typography>
                <Typography sx={checkbox_style}>&nbsp; Company</Typography>
              </Stack>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {errorMessageCompanyType.error && (
              <FormHelperText style={{ color: '#d32f2f' }}>
                {errorMessageCompanyType.helperText}
              </FormHelperText>
            )}
          </Grid>
          {checked && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={3}>
              <Grid item xs={12} sm={12} md={4}>
                <FormLabel sx={typography_textfield} variant="h6" required>
                  Company Name
                </FormLabel>
                <TextField
                  size="48px"
                  required={company}
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      textTransform: 'capitalize',
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                      },
                      '.Mui-error': {
                        textTransform: 'none',
                        // border:"1px solid blue"
                      },
                    },
                  ]}
                  fullWidth
                  helperText={
                    errorMessageCompanyName.helperText
                      ? errorMessageCompanyName.helperText
                          .charAt(0)
                          .toUpperCase() +
                        errorMessageCompanyName.helperText
                          .slice(1)
                          .toLowerCase()
                      : ''
                  }
                  error={errorMessageCompanyName.error}
                  placeholder="Enter company name"
                  id="companyname"
                  type="input"
                  name="companyname"
                  value={companyname}
                  onChange={(event) => {
                    // const allowedCharacters = event.target.value.replace(/[^a-zA-Z0-9\s!@#$%^&*()_+{}\[\]:;<>,.?~`=-]/g, "");
                    const companyName = event.target.value.trimStart();
                    if (companyName) {
                      setErrorMessageCompanyName({
                        helperText: '',
                        error: false,
                      });
                    }
                    setCompanyname(companyName);
                  }}
                />
                {errorMessageCompanyName && (
                  <div>{errorMessageCompanyName.error}</div>
                )}
              </Grid>
            </Grid>
          )}
          {owners.map((owner, index) => (
            <>
              {index !== 0 && (
                <Divider key={index} className={classes.Divider} />
              )}
              <Grid item xs={12} sm={12} md={4} id={`owner-${index}`}>
                <Box></Box>
                <FormLabel sx={typography_textfield} variant="h6" required>
                  First Name
                </FormLabel>
                <TextField
                  size="48px"
                  required
                  sx={[
                    textboxmargin,
                    {
                      height: '48px',
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                      },
                    },
                  ]}
                  fullWidth
                  autoComplete="off"
                  placeholder="Enter first name"
                  id="name"
                  type="text"
                  name="name"
                  // helperText={errorMessage.helperText}
                  // error={errorMessage.error}
                  error={!!nameErrors[index]}
                  helperText={nameErrors[index]}
                  value={userDetails?.firstName || owner?.firstname}
                  onKeyDown={handleKeyDown}
                  onClick={() => {
                    setLnameAnchorEl('');
                    setLegalAnchorEl('');
                    setEmailAnchorEl('');
                  }}
                  onChange={(e) => {
                    let input = e.target.value.trim();
                    const isNumeric = /^\d+$/.test(input.replace(/\s+/g, ''));

                    if (input) {
                      setNameErrors((prevErrors) => {
                        const newErrors = [...prevErrors];
                        newErrors[index] = '';
                        return newErrors;
                      });
                    }

                    if (isNumeric) {
                      // Remove non-digit characters and limit to 10 digits
                      const cleanedInput = input
                        .replace(/\D/g, '')
                        .slice(0, 10);

                      // Format to xxxx xxx xxx even after 5 digits
                      const formattedNumber = cleanedInput.replace(
                        /(\d{4})(\d{0,3})(\d{0,3})/,
                        (match, p1, p2, p3) =>
                          [p1, p2, p3].filter(Boolean).join(' ')
                      );

                      setAnchorEl(formattedNumber);
                      setLnameAnchorEl('');
                      setLegalAnchorEl('');
                      setEmailAnchorEl('');
                      vendorCheckin(formattedNumber);
                    } else {
                      setAnchorEl(input);
                      setLnameAnchorEl('');
                      setLegalAnchorEl('');
                      setEmailAnchorEl('');

                      vendorCheckin(input);
                      const inputValue = e.target.value;

                      const alphabetOnly = inputValue
                        .replace('/[^a-zA-Zs]/g', '')
                        .slice(0, 30);
                      const formatted =
                        alphabetOnly.charAt(0).toUpperCase() +
                        alphabetOnly.slice(1).toLowerCase();
                      e.target.value = formatted.trimStart();
                      setFirstname(
                        handleOwnerChange(
                          index,
                          'firstname',
                          formatted.trimStart()
                        )
                      );
                    }

                    setCurrentActiveIndex(index);
                  }}
                  inputProps={{
                    maxLength: 25,
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                />

                <Box
                  sx={{
                    position: 'relative',
                    display: 'block',
                    // overflowY: "auto", // Scroll only the list of users
                    //overflowX: "hidden",
                  }}
                >
                  {currentActiveIndex === index &&
                    anchorEl &&
                    !checkInErrorData && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '100%', // Positioned just below the TextField
                          right: 0, // Align with the TextField's left edge
                          minWidth: '320px',
                          maxHeight: '270px',
                          overflowY: 'auto', // Scroll only the list of users
                          overflowX: 'hidden',
                          // borderRadius: "8px",
                          boxShadow: 3,
                          // paddingTop: 2,

                          backgroundColor: '#fff',
                          zIndex: 1000,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {/* Scrollable list of users */}
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: 'scroll',
                            maxHeight: '150px',
                            paddingLeft: 2,
                            paddingTop: 2,
                            scrollbarWidth: 'thin !important',
                            '&:hover': {
                              overflowY: 'scroll',
                            },
                            '&::-webkit-scrollbar': {
                              display: 'block !important',
                              scrollbarWidth: 'thin !important',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#888 !important',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#555 !important',
                            },
                          }}
                        >
                          {checkInData &&
                          Array.isArray(checkInData?.userData) &&
                          checkInData?.userData.length > 0 ? (
                            <>
                              {checkInData.userData.map((dataItem, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: 1,
                                    padding: 1,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    handleMatchData(index, i);
                                    setCheckInIndex('1');
                                    setUserSelected(true);
                                    setAnchorEl('');
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 500,
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    {`${dataItem.userName} ${dataItem.userSurName}`}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontSize: '12px',
                                      color: '#999',
                                    }}
                                  >
                                    {dataItem.userEmail}
                                  </Typography>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <Typography>
                              No existing contact available
                            </Typography>
                          )}
                        </Box>
                        <Divider />
                        {/* Fixed "Add this as new contact" section */}
                        <Box
                          sx={{
                            paddingTop: 1,
                            paddingBottom: 1,
                            textAlign: 'center',
                          }}
                          onClick={() => {
                            setAnchorEl('');
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '14px',
                              color: '#007BFF',
                              cursor: 'pointer',
                            }}
                          >
                            {`+ Add this '${owner?.firstname}' as new contact`}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={4}>
                <FormLabel required sx={typography_textfield} variant="h6">
                  Last Name
                </FormLabel>
                <TextField
                  required
                  sx={{
                    ...textboxmargin,
                    '& .MuiInputBase-input::placeholder': {
                      textTransform: 'none',
                    },
                  }}
                  // helperText={errorMessageLastName.helperText}
                  // error={errorMessageLastName.error}
                  error={!!lastnameErrors[index]}
                  helperText={lastnameErrors[index]}
                  fullWidth
                  autoComplete="off"
                  placeholder="Enter last name"
                  id="surname"
                  type="input"
                  name="surname"
                  value={userDetails?.lastName || owner?.lastname}
                  onKeyDown={handleKeyDown}
                  onClick={() => {
                    setAnchorEl('');
                    setLegalAnchorEl('');
                    setEmailAnchorEl('');
                    setMobileAnchorEl('');
                    setCurrentActiveIndex(index);
                  }}
                  onChange={(event) => {
                    const inputValue = event.target.value;

                    const alphabetOnly = inputValue
                      .replace(/[^a-zA-Z\s]/g, '')
                      .slice(0, 30);
                    let formatted =
                      alphabetOnly.charAt(0).toUpperCase() +
                      alphabetOnly.slice(1).toLowerCase();
                    event.target.value = formatted;
                    if (formatted) {
                      setLastnameErrors((prevErrors) => {
                        const newErrors = [...prevErrors];
                        newErrors[index] = '';
                        return newErrors;
                      });
                    }
                    // event.target.value = alphabetOnly;

                    setLastname(formatted);
                    vendorCheckin(formatted);
                    setLnameAnchorEl(formatted);
                    setAnchorEl('');
                    setLegalAnchorEl('');
                    setEmailAnchorEl('');
                    setMobileAnchorEl('');
                    // setCurrentActiveIndex(index);
                    setLastname(
                      handleOwnerChange(
                        index,
                        'lastname',
                        formatted.trimStart()
                      )
                    );
                    setCurrentActiveIndex(index);
                  }}
                  inputProps={{
                    maxLength: 25,
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                />

                <Box
                  sx={{
                    position: 'relative',
                    display: 'block',
                    // overflowY: "auto", // Scroll only the list of users
                    //overflowX: "hidden",
                  }}
                >
                  {currentActiveIndex == index &&
                    lnameAnchorEl &&
                    !checkInErrorData && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '100%', // Positioned just below the TextField
                          right: 0, // Align with the TextField's left edge
                          minWidth: '320px',
                          maxHeight: '270px',
                          overflowY: 'auto', // Scroll only the list of users
                          overflowX: 'hidden',
                          // borderRadius: "8px",
                          boxShadow: 3,
                          // paddingTop: 2,

                          backgroundColor: '#fff',
                          zIndex: 1000,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {/* Scrollable list of users */}
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: 'scroll',
                            maxHeight: '150px',
                            paddingLeft: 2,
                            paddingTop: 2,
                            scrollbarWidth: 'thin !important',
                            '&:hover': {
                              overflowY: 'scroll',
                            },
                            '&::-webkit-scrollbar': {
                              display: 'block !important',
                              scrollbarWidth: 'thin !important',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#888 !important',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#555 !important',
                            },
                          }}
                        >
                          {checkInData &&
                          Array.isArray(checkInData?.userData) &&
                          checkInData?.userData.length > 0 ? (
                            <>
                              {checkInData.userData.map((dataItem, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: 1,
                                    padding: 1,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    handleMatchData(index, i);
                                    setCheckInIndex('1');
                                    setUserSelected(true);
                                    setLnameAnchorEl('');
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 500,
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    {`${dataItem.userName} ${dataItem.userSurName}`}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontSize: '12px',
                                      color: '#999',
                                    }}
                                  >
                                    {dataItem.userEmail}
                                  </Typography>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <Typography>
                              No existing contact available
                            </Typography>
                          )}
                        </Box>
                        <Divider />
                        {/* Fixed "Add this as new contact" section */}
                        <Box
                          sx={{
                            paddingTop: 1,
                            paddingBottom: 1,
                            textAlign: 'center',
                          }}
                          onClick={() => {
                            setLnameAnchorEl('');
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '14px',
                              color: '#007BFF',
                              cursor: 'pointer',
                            }}
                          >
                            {`+ Add this '${owner?.lastname}' as new contact`}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <FormLabel required sx={typography_textfield} variant="h6">
                  Legal Name
                </FormLabel>
                <TextField
                  required
                  sx={{
                    ...textboxmargin,
                    '& .MuiInputBase-input::placeholder': {
                      textTransform: 'none',
                    },
                  }}
                  fullWidth
                  // helperText={errorMessageLegal.helperText}
                  // error={errorMessageLegal.error}
                  error={!!legalnameErrors[index]}
                  helperText={legalnameErrors[index]}
                  placeholder="Enter full legal name"
                  id="legalname"
                  type="input"
                  name="legalname"
                  autoComplete="off"
                  value={owner?.legalname}
                  onKeyDown={handleKeyDown}
                  onClick={() => {
                    setAnchorEl('');
                    setLnameAnchorEl('');
                    setEmailAnchorEl('');
                    setMobileAnchorEl('');
                  }}
                  onChange={(event) => {
                    const inputValue = event.target.value;

                    const alphabetOnly = inputValue
                      .replace('[a-zA-Zs]*', '')
                      .slice(0, 30);

                    let formatted =
                      alphabetOnly.charAt(0).toUpperCase() +
                      alphabetOnly.slice(1).toLowerCase();

                    event.target.value = formatted;
                    if (formatted) {
                      setLegalnameErrors((prevErrors) => {
                        const newErrors = [...prevErrors];
                        newErrors[index] = '';
                        return newErrors;
                      });
                    }
                    vendorCheckin(formatted);
                    setLegalAnchorEl(formatted);

                    setAnchorEl('');
                    setLnameAnchorEl('');
                    setEmailAnchorEl('');
                    setMobileAnchorEl('');

                    setLegalname(
                      handleOwnerChange(
                        index,
                        'legalname',
                        formatted.trimStart()
                      )
                    );

                    setCurrentActiveIndex(index);
                  }}
                  inputProps={{
                    maxLength: 30,
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                />

                {/* suggestion for legalname */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'block',
                    // overflowY: "auto", // Scroll only the list of users
                    //overflowX: "hidden",
                  }}
                >
                  {currentActiveIndex == index &&
                    legalAnchorEl &&
                    !checkInErrorData && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '100%', // Positioned just below the TextField
                          right: 0, // Align with the TextField's left edge
                          minWidth: '320px',
                          maxHeight: '270px',
                          overflowY: 'auto', // Scroll only the list of users
                          overflowX: 'hidden',
                          // borderRadius: "8px",
                          boxShadow: 3,
                          // paddingTop: 2,

                          backgroundColor: '#fff',
                          zIndex: 1000,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {/* Scrollable list of users */}
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: 'scroll',
                            maxHeight: '150px',
                            paddingLeft: 2,
                            paddingTop: 2,
                            scrollbarWidth: 'thin !important',
                            '&:hover': {
                              overflowY: 'scroll',
                            },
                            '&::-webkit-scrollbar': {
                              display: 'block !important',
                              scrollbarWidth: 'thin !important',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#888 !important',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#555 !important',
                            },
                          }}
                        >
                          {checkInData &&
                          Array.isArray(checkInData?.userData) &&
                          checkInData?.userData.length > 0 ? (
                            <>
                              {checkInData.userData.map((dataItem, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: 1,
                                    padding: 1,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    handleMatchData(index, i);
                                    setCheckInIndex('1');
                                    setUserSelected(true);
                                    setLegalAnchorEl('');
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 500,
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    {`${dataItem.userName} ${dataItem.userSurName}`}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontSize: '12px',
                                      color: '#999',
                                    }}
                                  >
                                    {dataItem.userEmail}
                                  </Typography>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <Typography>
                              No existing contact available
                            </Typography>
                          )}
                        </Box>
                        <Divider />
                        {/* Fixed "Add this as new contact" section */}
                        <Box
                          sx={{
                            paddingTop: 1,
                            paddingBottom: 1,
                            textAlign: 'center',
                          }}
                          onClick={() => {
                            setLegalAnchorEl('');
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '14px',
                              color: '#007BFF',
                              cursor: 'pointer',
                            }}
                          >
                            {`+ Add this '${owner?.legalname}' as new contact`}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={{ marginTop: !matchesmd && '24px' }}
              >
                <FormLabel required sx={typography_textfield} variant="h6">
                  Email
                </FormLabel>
                <TextField
                  required
                  sx={textboxmargin}
                  fullWidth
                  helperText={
                    !isValidEmail ? (
                      <span
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '16',
                          color: '#F93939',
                        }}
                      >
                        Invalid email format
                      </span>
                    ) : (
                      emailErrors[index]
                    )
                  }
                  error={!!emailErrors[index]}
                  placeholder="name@Example:.com.au"
                  id="email"
                  type="email"
                  name="email"
                  autoComplete="off"
                  value={userDetails?.email || owner?.email}
                  onClick={() => {
                    setAnchorEl('');
                    setLnameAnchorEl('');
                    setLegalAnchorEl('');
                    setMobileAnchorEl('');
                  }}
                  onKeyDown={(e) => {
                    if (e.key === ' ') {
                      e.preventDefault();
                    }
                  }}
                  onChange={(event) => {
                    const lowercaseEmail = event.target.value.toLowerCase();

                    setEmailAnchorEl(lowercaseEmail);
                    setAnchorEl('');
                    setLnameAnchorEl('');
                    setLegalAnchorEl('');
                    setMobileAnchorEl('');

                    vendorCheckin(lowercaseEmail);

                    setEmail(handleOwnerChange(index, 'email', lowercaseEmail));

                    setCurrentActiveIndex(index);
                  }}
                />

                <span
                  style={{
                    fontWeight: 'bold',
                    color: 'red',
                  }}
                >
                  {emailError}
                </span>

                {/* suggestion for email */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'block',
                    // overflowY: "auto", // Scroll only the list of users
                    //overflowX: "hidden",
                  }}
                >
                  {currentActiveIndex == index &&
                    emailAnchorEl &&
                    !checkInErrorData && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '100%', // Positioned just below the TextField
                          right: 0, // Align with the TextField's left edge
                          minWidth: '320px',
                          maxHeight: '270px',
                          overflowY: 'auto', // Scroll only the list of users
                          overflowX: 'hidden',
                          // borderRadius: "8px",
                          boxShadow: 3,
                          // paddingTop: 2,

                          backgroundColor: '#fff',
                          zIndex: 1000,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {/* Scrollable list of users */}
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: 'scroll',
                            maxHeight: '150px',
                            paddingLeft: 2,
                            paddingTop: 2,
                            scrollbarWidth: 'thin !important',
                            '&:hover': {
                              overflowY: 'scroll',
                            },
                            '&::-webkit-scrollbar': {
                              display: 'block !important',
                              scrollbarWidth: 'thin !important',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#888 !important',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#555 !important',
                            },
                          }}
                        >
                          {checkInData &&
                          Array.isArray(checkInData?.userData) &&
                          checkInData?.userData.length > 0 ? (
                            <>
                              {checkInData.userData.map((dataItem, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: 1,
                                    padding: 1,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    handleMatchData(index, i);
                                    setCheckInIndex('1');
                                    setUserSelected(true);
                                    setEmailAnchorEl('');
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 500,
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    {`${dataItem.userName} ${dataItem.userSurName}`}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontSize: '12px',
                                      color: '#999',
                                    }}
                                  >
                                    {dataItem.userEmail}
                                  </Typography>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <Typography>
                              No existing contact available
                            </Typography>
                          )}
                        </Box>
                        <Divider />
                        {/* Fixed "Add this as new contact" section */}
                        <Box
                          sx={{
                            paddingTop: 1,
                            paddingBottom: 1,
                            textAlign: 'center',
                          }}
                          onClick={() => {
                            setLegalAnchorEl('');
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '14px',
                              color: '#007BFF',
                              cursor: 'pointer',
                            }}
                          >
                            {`+ Add this '${owner?.email}' as new contact`}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={{ marginTop: !matchesmd && '24px' }}
              >
                <FormLabel required sx={typography_textfield} variant="h6">
                  Mobile
                </FormLabel>
                <Stack
                  direction="row"
                  alignItems="flex-start"
                  spacing={1}
                  mt={'5px'}
                >
                  <TextField
                    fullWidth
                    placeholder="Enter your mobile phone number"
                    id="mobile"
                    name="mobile"
                    autoComplete="off"
                    sx={{
                      ...textboxmargin,
                      '& .MuiInputBase-input::placeholder': {
                        fontSize: matches ? '15px' : '16px',
                        textTransform: 'none',
                      },
                    }}
                    value={userDetails?.phone || owner.mobile}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    onClick={() => {
                      setAnchorEl('');
                      setEmailAnchorEl('');
                    }}
                    onChange={(event) => {
                      vendorCheckin(event.target.value);
                      setMobileAnchorEl(event.target.value);
                      setAnchorEl('');
                      setCurrentActiveIndex(index);
                      handleMobileChange(event, index);
                    }}
                    inputProps={{ inputMode: 'numeric', maxLength: 12 }}
                    error={!!mobileErrors[index]}
                    helperText={mobileErrors[index]}
                  />

                  {index !== 0 && (
                    <IconButton
                      onClick={() => handleOwnerDelete(index)}
                      sx={{ mt: '4px' }} // small visual adjustment
                    >
                      <DeleteForeverOutlinedIcon
                        sx={{
                          color: '#965CF0',
                          fontSize: 28,
                        }}
                      />
                    </IconButton>
                  )}
                </Stack>

                {/* suggestion for mobile number */}
                <Box
                  sx={{
                    position: 'relative',
                    display: 'block',
                    // overflowY: "auto", // Scroll only the list of users
                    //overflowX: "hidden",
                  }}
                >
                  {currentActiveIndex == index &&
                    mobileAnchorEl &&
                    !checkInErrorData && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '100%', // Positioned just below the TextField
                          right: 0, // Align with the TextField's left edge
                          minWidth: '320px',
                          maxHeight: '270px',
                          overflowY: 'auto', // Scroll only the list of users
                          overflowX: 'hidden',
                          // borderRadius: "8px",
                          boxShadow: 3,
                          // paddingTop: 2,

                          backgroundColor: '#fff',
                          zIndex: 1000,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        {/* Scrollable list of users */}
                        <Box
                          sx={{
                            flexGrow: 1,
                            overflowY: 'scroll',
                            maxHeight: '150px',
                            paddingLeft: 2,
                            paddingTop: 2,
                            scrollbarWidth: 'thin !important',
                            '&:hover': {
                              overflowY: 'scroll',
                            },
                            '&::-webkit-scrollbar': {
                              display: 'block !important',
                              scrollbarWidth: 'thin !important',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#888 !important',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#555 !important',
                            },
                          }}
                        >
                          {checkInData &&
                          Array.isArray(checkInData?.userData) &&
                          checkInData?.userData.length > 0 ? (
                            <>
                              {checkInData.userData.map((dataItem, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: 1,
                                    padding: 1,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    handleMatchData(index, i);
                                    setCheckInIndex('1');
                                    setUserSelected(true);
                                    setMobileAnchorEl('');
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 500,
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    {`${dataItem.userName} ${dataItem.userSurName}`}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontSize: '12px',
                                      color: '#999',
                                    }}
                                  >
                                    {dataItem.userEmail}
                                  </Typography>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <Typography>
                              No existing contact available
                            </Typography>
                          )}
                        </Box>
                        <Divider />
                        {/* Fixed "Add this as new contact" section */}
                        <Box
                          sx={{
                            paddingTop: 1,
                            paddingBottom: 1,
                            textAlign: 'center',
                          }}
                          onClick={() => {
                            setMobileAnchorEl('');
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '14px',
                              color: '#007BFF',
                              cursor: 'pointer',
                            }}
                          >
                            {`+ Add this '${owner?.mobile}' as new contact`}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
              {/* {
              index == 0 && */}
              {owners.length > 1 && (
                <Grid key={index} item xs={12} sm={12} md={12}>
                  <Stack flexDirection={'row'}>
                    <Typography>
                      <input
                        required={
                          !owners.some((o, i) => o.primary && i !== index)
                        }
                        type="checkbox"
                        checked={owner.primary}
                        onChange={() => handlePrimaryChange(index)}
                      />
                    </Typography>
                    <Typography>&nbsp; Primary</Typography>
                  </Stack>
                </Grid>
              )}
            </>
          ))}

          <Grid
            sx={{ marginBottom: matches700 && '50px' }}
            className={classes.GridBox}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
                gap: '20px',
                flexWrap: 'wrap',
                alignItems: 'center',
              }}
              style={{}}
            >
              <Button
                disabled={loading}
                variant="outlined"
                // sx={{ ...cancelBtn, }}
                // className={classes.cancelBtn}
                sx={{
                  ...poppins500,
                  fontSize: '16px',
                  color: 'black',
                  // width: "210px",
                  // height: "48px",
                  background: '#FFFFFF',
                  whiteSpace: 'nowrap',
                  border: '1px solid #DFDFDF',
                  borderRadius: '8px',
                  textTransform: 'inherit',
                  padding: matchesmd ? '5px 25px' : '12px 76px 12px 76px',
                  ' &:hover': {
                    backgroundColor: '#FFFFFF !important',
                    color: '#6C2AD2',
                    border: '1px solid #6C2AD2 !important ',
                  },
                }}
                onClick={() => {
                  onClose();
                  setValue(0);
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={loading}
                variant="outlined"
                // className={classes.AdditionalOwner}
                sx={{
                  ...poppins500,
                  fontSize: '16px',
                  color: 'black',
                  // width: "351px",
                  // height: "48px",
                  background: '#FFFFFF',
                  whiteSpace: 'nowrap',
                  border: '1px solid #DFDFDF',
                  borderRadius: '8px',
                  textTransform: 'inherit',
                  padding: matchesmd ? '5px 25px' : '12px 76px 12px 76px',
                  ' &:hover': {
                    backgroundColor: '#FFFFFF !important',
                    color: '#6C2AD2',
                    border: '1px solid #6C2AD2 !important ',
                  },
                }}
                // sx={{ ...addAdditionalOwner }}
                onClick={handleClick}
              >
                {matches700 ? '+ Add Owner' : '+ Add Additional Owner'}
              </Button>
              <Button
                disabled={loading}
                variant="outlined"
                // className={classes.nextBtn}
                // type="submit"
                sx={{
                  backgroundColor: '#965CF0 !important',
                  ...poppins500,
                  color: '#FFFFFF !important',
                  fontSize: '16px',
                  borderRadius: '8px',
                  whiteSpace: 'nowrap',
                  // width: "210px",
                  // height: "48px",
                  textTransform: 'inherit',
                  padding: matchesmd ? '5px 25px' : '12px 76px 12px 76px',
                  border: '1px solid #AF05FF !important',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  ' &:hover': {
                    backgroundColor: '#965CF0 !important',
                    border: '1px solid #AF05FF !important ',
                  },
                }}
                onClick={() => {
                  handleOwnershipSubmit();
                  // sectionRef.current.scrollTo({ behavior: "smooth", block: "start" });
                }}
              >
                {fromHeader == 'no' || fromHeader == 'appraisal'
                  ? 'Next'
                  : 'Submit'}
              </Button>
              {loading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px', marginLeft: '10px' }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </form>

      <Dialog
        open={addMoreField}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            {/* <Pendingwarning /> */}

            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Add Details
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '10px',
                paddingLeft: '12px',
              }}
            >
              Do you want to add property Details?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                onClick={closeAddFieldConfirmBox}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                onClick={confirmAddmoreField}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}

export const handleKeyDown = (event) => {
  if (event.key.match(/[0-9]/)) {
    event.preventDefault(); // Prevent typing numbers
  }
};
const useStyles = makeStyles((theme) => ({
  noSpinArrows: {
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
      {
        '-webkit-appearance': 'none',
        margin: 0,
      },
  },
  ownerTitle: {
    fontSize: '24px !important',
    fontWeight: '500px !important',
    fontFamily: 'Poppins !important',
    textAlign: 'left !important',
    color: '#687999 !important',
    fontStyle: 'Medium !important',
    padding: '10px 0px 10px 0px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
      fontWeight: '500px !important',
      fontFamily: 'Poppins !important',
      textAlign: 'left !important',
      fontStyle: 'Medium !important',
      padding: '10px 0px 10px 0px !important',
    },
  },
  GridRow: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  AdditionalOwner: {
    fontFamily: 'Poppins !important',
    fontSize: '16px',
    color: '#000 !important',
    width: '351px',
    height: '48px',
    margin: '10px !important',
    background: '#FFFFFF !important',
    border: '1px solid #DFDFDF !important',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 73px 12px 73px',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2 !important',
      border: '1px solid #6C2AD2 !important ',
    },
    [theme.breakpoints.down('md')]: {
      width: 'auto !important',
      height: '48px',
    },
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  GridBox: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  nextBtn: {
    margin: '10px !important',
    backgroundColor: '#965CF0 !important',
    fontFamily: 'Poppins !important',
    color: '#FFFFFF !important',
    fontSize: '16px',
    borderRadius: '8px !important',
    width: '210px',
    height: '48px',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    border: '1px solid #AF05FF !important',
    ' &:hover': {
      backgroundColor: '#965CF0 !important',
      border: '1px solid #AF05FF !important ',
    },
  },
  cancelBtn: {
    fontSize: '16px',
    fontFamily: 'Poppins !important',
    color: 'black',
    width: '210px',
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #DFDFDF',
    borderRadius: '8px',
    textTransform: 'inherit',
    padding: '12px 76px 12px 76px',
    margin: '10px !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2',
      border: '1px solid #6C2AD2 !important ',
    },
  },
  Divider: {
    width: '100%',
    margin: '15px 10px 20px 10px !important',
    padding: '10px',
  },
}));

export const BuyerFound = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4427 0C12.5784 0 12.7085 0.0577719 12.8044 0.160606C12.9003 0.263441 12.9542 0.402915 12.9542 0.548345V2.19338H14.4885C14.6242 2.19338 14.7543 2.25115 14.8502 2.35398C14.9461 2.45682 15 2.59629 15 2.74172C15 2.88715 14.9461 3.02663 14.8502 3.12946C14.7543 3.2323 14.6242 3.29007 14.4885 3.29007H12.9542V4.9351C12.9542 5.08053 12.9003 5.22 12.8044 5.32284C12.7085 5.42567 12.5784 5.48345 12.4427 5.48345C12.3071 5.48345 12.177 5.42567 12.0811 5.32284C11.9851 5.22 11.9313 5.08053 11.9313 4.9351V3.29007H10.3969C10.2612 3.29007 10.1312 3.2323 10.0352 3.12946C9.93932 3.02663 9.88544 2.88715 9.88544 2.74172C9.88544 2.59629 9.93932 2.45682 10.0352 2.35398C10.1312 2.25115 10.2612 2.19338 10.3969 2.19338H11.9313V0.548345C11.9313 0.402915 11.9851 0.263441 12.0811 0.160606C12.177 0.0577719 12.3071 0 12.4427 0ZM5.45282 3.65563C5.13938 3.65563 4.82901 3.72182 4.53943 3.85042C4.24985 3.97902 3.98673 4.16751 3.7651 4.40513C3.54347 4.64275 3.36766 4.92484 3.24771 5.23531C3.12776 5.54577 3.06602 5.87853 3.06602 6.21457C3.06602 6.55062 3.12776 6.88337 3.24771 7.19384C3.36766 7.5043 3.54347 7.7864 3.7651 8.02402C3.98673 8.26164 4.24985 8.45013 4.53943 8.57872C4.82901 8.70732 5.13938 8.77351 5.45282 8.77351C6.08584 8.77351 6.69293 8.50391 7.14054 8.02402C7.58815 7.54412 7.83961 6.89325 7.83961 6.21457C7.83961 5.5359 7.58815 4.88502 7.14054 4.40513C6.69293 3.92523 6.08584 3.65563 5.45282 3.65563ZM2.04311 6.21457C2.04315 5.58823 2.1933 4.97241 2.47915 4.42616C2.76499 3.87992 3.17696 3.42157 3.67552 3.0951C4.17409 2.76862 4.74253 2.58495 5.32633 2.56172C5.91014 2.53848 6.48972 2.67646 7.00949 2.96241C7.52926 3.24836 7.97178 3.67269 8.29462 4.19471C8.61745 4.71673 8.80977 5.31893 8.85312 5.94354C8.89648 6.56816 8.78942 7.19424 8.54221 7.76174C8.29499 8.32924 7.91593 8.81912 7.44136 9.18441C8.42599 9.60506 9.27447 10.3251 9.88244 11.2559C10.4904 12.1868 10.8314 13.2878 10.8633 14.4237C10.8668 14.4966 10.8567 14.5695 10.8335 14.6382C10.8104 14.7068 10.7746 14.7698 10.7285 14.8235C10.6823 14.8772 10.6266 14.9204 10.5646 14.9507C10.5026 14.9809 10.4356 14.9976 10.3676 14.9998C10.2995 15.0019 10.2317 14.9895 10.1682 14.9631C10.1047 14.9368 10.0467 14.8972 9.99764 14.8465C9.94861 14.7958 9.9095 14.7352 9.88262 14.6681C9.85574 14.601 9.84163 14.5288 9.84111 14.4558C9.80619 13.227 9.32632 12.061 8.5032 11.2049C7.68009 10.3489 6.57841 9.87019 5.43168 9.87019C4.28494 9.87019 3.18327 10.3489 2.36015 11.2049C1.53704 12.061 1.05716 13.227 1.02225 14.4558C1.01542 14.599 0.956559 14.7336 0.858279 14.8308C0.759998 14.9281 0.630114 14.9801 0.49645 14.9759C0.362786 14.9717 0.235975 14.9116 0.143182 14.8083C0.0503901 14.7051 -0.00100239 14.567 1.48171e-05 14.4237C0.0323171 13.2825 0.376478 12.1766 0.989783 11.2432C1.60309 10.3099 2.45854 9.59019 3.44996 9.17344C3.01393 8.83465 2.65907 8.38982 2.41451 7.87546C2.16996 7.36111 2.04267 6.7919 2.04311 6.21457Z"
        fill="#666666"
      />
    </svg>
  );
};
